export const onHandleShowTableMenu = (index, activeTableMenu, setActiveTableMenu, e) => {
    e.stopPropagation()
        if(activeTableMenu !== index) {
            setActiveTableMenu(index)
        } else {
            setActiveTableMenu(null)
        }
    }
